<template>
    <div>
        <header-portrate />
        <exports-print ref="exportbar" />

    <div class="m-2">
        <bread-crumbs :items="items"></bread-crumbs>
        <tabs-comp :tabs="tabs" />

        <v-row class="m-2" :style="`direction:`+lang.dir+`;margin:5px;margin-top:38px !important;margin-left:30px;margin-right:30px;`">
            <v-col cols="12" md="8" sm="12" :style="`direction:${lang.dir}`">
                <form autocomplete="off" @submit.prevent="searchCats()">
                    <v-row>
                        <v-col cols="12" md="4">
                            <div style="text-align:start;">
                                <div class="mobileFont">{{lang.category_name}}</div>
                                <b-form-input class="inborder" v-model="search" style="background:#efefef;" />
                            </div>
                        </v-col>
                        <v-col cols="12" md="3">
                            <div style="text-align:start;">
                                <div class="mobileFont">{{catLabels.rows_per_page}}</div>
                                <b-form-select class="selborder" v-model="perPage" :options="perPageOptions" @change="searchCats()" />
                            </div>
                        </v-col>
                        <v-col cols="12" md="3">
                            <div>
                                <div>&nbsp;</div>
                                <b-button variant="light" style="padding-top:2px !important; padding-bottom:2px !important;background:blue;color:#fff;width:75px;" class="btnMobile" @click="searchCats()">{{lang.search}}</b-button>
                            </div>
                        </v-col>
                    </v-row>
                </form>
            </v-col>
            <v-col cols="12" md="4" sm="12" :style="`padding-inline-start:30px !important;direction:`+lang.ldir" class="text-end">
                <button id="multiply-button" :style="`direction:`+lang.dir+`;margin-top:22px;`" :class="`multiply-button-`+lang.lalgin" @click="addnew({id:0})" v-b-toggle.add_category>
                    <div style="width:150px" :class="`multiply-button-content-`+lang.lalgin">{{lang.add}}</div>
                </button>
            </v-col>
            <v-col cols="12" style="padding-inline-end:30px !important;padding-top:15px;">
                <v-data-table
                    :headers="headers"
                    :items="product_categories"
                    disable-pagination
                    hide-default-footer
                    width="100%"
                    id="MainTable"
                >
                    <template slot="body.prepend">
                        <tr>
                        <td style="font-size:.1rem !important;background:#fff !important;border-inline :none !important;border-top:1px solid #000 !important;border-bottom :2px solid #bbb !important;" :colspan="headers.length">&#32;</td>
                        </tr>
                    </template>
                    <template v-slot:item="row">
                        <tr>
                            <td style="width:30%;" class="text-center">{{ row.item.namear }}</td>
                            <td class="text-center" nowrap>{{ row.item.nameen }}</td>
                            <td style="width:10%;" class="text-center" nowrap>{{ row.item._type }}</td>
                            <td style="width:10%;" class="text-center">{{ row.item._parent }}</td>
                            <td style="width:8%;" class="text-center">{{ row.item.subcats }}</td>
                            <td style="width:8%;" class="text-center">{{ row.item.products }}</td>
                            <td style="width:90px;cursor:pointer;" class="text-center" @click="togglePos(row.item)">
                                <span :style="posChipStyle(row.item)">{{ row.item.show_in_pos == 1 ? catLabels.yes : catLabels.no }}</span>
                            </td>
                            <td style="width:80px;background:red !important; border:2px solid #fff !important;color:#fff;" class="text-center">
                                <div style="color:#fff;cursor:pointer;" v-if="row.item.products == 0 && row.item.subcats == 0" @click="delItem(row.item)">{{lang.delete}}</div>
                            </td>
                            <td style="width:80px;background:blue !important; border:2px solid #fff !important;color:#fff;" class="text-center">
                                <div style="color:#fff;cursor:pointer;" v-b-toggle.add_category @click="addnew(row.item)">{{lang.update}}</div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
            <v-col cols="12" style="margin-bottom:25px;margin-top:-15px;">
                <v-container>
                    <div class="text-center pt-2">
                        <div style="font-size:12px;color:#555;margin-bottom:5px;">
                            {{ catLabels.total_rows }}: {{ totalRows }}
                        </div>
                        <v-pagination
                            v-model="page"
                            :length="pageCount"
                            :total-visible="9"
                            color="#000"
                            @input="getNext(page)"
                        ></v-pagination>
                    </div>
                </v-container>
            </v-col>
        </v-row>
        <vue-snotify></vue-snotify>
        <products-addcats ref="AddCategory" />
    </div>
        <Footer />
    </div>
</template>

<script>
import axios from 'axios'
import breadCrumbs from '@/components/breadCrumbs.vue';
import TabsComp from '@/components/tabsComp.vue';
import ProductsAddcats from '@/components/products-addcats.vue';
import HeaderPortrate from '@/components/Header-Portrate.vue';
import Footer from '@/components/Footer.vue';
import ExportsPrint from '@/components/exports-print.vue'
import { getVisibleTabsForRoute } from '@/menu/menuService'
export default{
  components: { breadCrumbs, TabsComp, ProductsAddcats, HeaderPortrate,Footer,ExportsPrint},
    name: 'Products',
    data() {
        return {
            active_tab:0,
            fieldRules: [
                v => !!v || 'الحقل مطلوب',
            ],
            product_categories: [],
            // Installs with thousands of categories cannot render the whole
            // table at once, so the list is fetched a page at a time.
            search: '',
            page: 1,
            cpage: 0,
            perPage: 25,
            pageCount: 0,
            totalRows: 0,
        }
    },
    created() {
        this.getCats();
    },
    methods: {
        collectSearch(){
            return {
                module: 'inventoryCategproes',
                elements: {
                    status: 1
                }
            }
        },
        posChipStyle(item){
            const on = item.show_in_pos == 1;
            return `display:inline-block;min-width:46px;padding:1px 8px;border-radius:10px;color:#fff;`
                + `background:${on ? '#0a7d2b' : '#999'};`;
        },
        /**
         * Flips the POS visibility of one category. Only the id and the flag are
         * sent; the save endpoint leaves every field it is not given alone.
         */
        togglePos(item){
            const next = item.show_in_pos == 1 ? 0 : 1;
            const post = new FormData();
            post.append('type','addUpdateCat');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[lang]',this.lang.langname);
            post.append('data[id]',item.id);
            post.append('data[show_in_pos]',next);
            axios.post(this.$store.state.SAMCOTEC.r_path, post)
            .then(() => {
                // Update in place so the row does not jump while the user works.
                this.$set(item, 'show_in_pos', next);
            });
        },
        delItem(item) {
            const post = new FormData();
            post.append("type","DelCats");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',item.id);
            post.append('data[lang]',this.lang.langname);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            )
            .then(() => {
                this.getCats();
            });
        },
        addnew(item){
            if(item.id == 0){
                this.$refs.AddCategory.namear = '';
                this.$refs.AddCategory.nameen = '';
                this.$refs.AddCategory.setParent(0, '');
                this.$refs.AddCategory.changeType(1);
                this.$refs.AddCategory.show_in_pos = 1;
                this.$refs.AddCategory.id = 0;
            }else{
                this.$refs.AddCategory.namear = item.namear;
                this.$refs.AddCategory.nameen = item.nameen;
                this.$refs.AddCategory.setParent(
                    item.parentid == 0 ? 0 : item.parentid,
                    item.parentid == 0 ? '' : (item._parent || '')
                );
                this.$refs.AddCategory.changeType(item.type == 0 ? 0 : 1);
                this.$refs.AddCategory.show_in_pos = item.show_in_pos == 0 ? 0 : 1;
                this.$refs.AddCategory.id = item.id;
            }
        },
        getNext(page){
            this.cpage = parseInt(page) - 1;
            this.getCats();
        },
        // Searching from page 9 would otherwise ask for page 9 of the new,
        // shorter result.
        searchCats(){
            this.cpage = 0;
            this.page = 1;
            this.getCats();
        },
        getCats(){
            const post = new FormData();
            post.append("type","getPCats");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',"all");
            post.append('data[lang]',this.lang.langname);
            // Sending a limit is what puts the endpoint into paged mode; the POS
            // and the pickers omit it and still get the full branch of the tree.
            post.append('data[limit]',this.perPage);
            post.append('data[cpage]',this.cpage);
            post.append('data[search]',this.search);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            )
            .then((res) => {
                const p = (res && res.data && res.data.results) ? res.data.results : null;
                this.product_categories = [];
                if(!p){
                    this.pageCount = 0;
                    this.totalRows = 0;
                    return;
                }

                this.product_categories = Array.isArray(p.data) ? p.data : [];
                this.totalRows = parseInt(p.allres || 0);
                this.pageCount = parseInt(p.pages || 0);

                // The server clamps the page when a filter leaves it past the
                // end; follow it so the pager highlights the page being shown.
                const servedPage = parseInt(p.page || 0) + 1;
                if(servedPage !== this.page){
                    this.cpage = servedPage - 1;
                    this.page = servedPage;
                }
            });
        },
        preparedata(){
            let exdata = {
                list: "prCatsList",
                title: this.lang.product_categories,
                data: [],
            }
            for(let i=0;i<this.product_categories.length;i++){
                exdata.data.push(this.product_categories[i]);
            }
            this.$refs.exportbar.exportdata = exdata;
            this.$refs.exportbar.sdate = '';
            this.$refs.exportbar.edate = '';

            this.$refs.exportbar.exporttitle = "";
            this.$refs.exportbar.palte_number = '';
            this.$refs.exportbar.contact_number = '';

        },
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        catLabels: function(){
            return {
                show_in_pos: this.lang.show_in_pos || 'Show on POS',
                rows_per_page: this.lang.rows_per_page || 'Rows per page',
                total_rows: this.lang.total_rows || 'Total',
                yes: this.lang.yes || 'Yes',
                no: this.lang.no || 'No',
            }
        },
        perPageOptions: function(){
            return [
                { text: '25', value: 25 },
                { text: '50', value: 50 },
                { text: '100', value: 100 },
                { text: '200', value: 200 },
            ]
        },
        headers: function(){
            return [
                {
                    text: this.lang.category_name_ar,
                    align: 'center',
                    filterable: false,
                    value: 'namear',
                    class: 'backBlack'
                },
                {
                    text: this.lang.category_name_en,
                    align: 'center',
                    filterable: false,
                    value: 'nameen',
                    class: 'backBlack'
                },
                {
                    text: this.lang.category_type,
                    align: 'center',
                    filterable: false,
                    value: 'type',
                    class: 'backBlack'
                },
                {
                    text: this.lang.category_parent,
                    align: 'center',
                    filterable: false,
                    value: 'parentid',
                    class: 'backBlack'
                },
                {
                    text: this.lang.subcat_count,
                    align: 'center',
                    filterable: false,
                    value: 'subcat_count',
                    class: 'backBlack'
                },
                {
                    text: this.lang.products,
                    align: 'center',
                    filterable: false,
                    value: 'products',
                    class: 'backBlack'
                },
                {
                    text: this.catLabels.show_in_pos,
                    align: 'center',
                    filterable: false,
                    value: 'show_in_pos',
                    class: 'backBlack'
                },
                {
                    text: this.lang.delete,
                    align: 'center',
                    filterable: false,
                    class: 'backBlack',
                    value: '',
                },
                {
                    text: this.lang.action,
                    align: 'center',
                    filterable: false,
                    class: 'backBlue',
                    value: '',
                },
            ]
        },
        tabs: function() {

            return getVisibleTabsForRoute(this.$store.getters['state'], this.lang, this.$route.path);

        },
        items: function() {
            return {
                    text: this.lang.product_categories,
                    disabled: true,
                    to: '/inventory/products',
                }
        }
    },
}
</script>
